import axios from "axios";

const api = axios.create({ baseURL: "/api" });

// Auth token interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pennymacs_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const adminLogin = (email, password) => api.post("/admin/login", { email, password });
export const verifyAdmin = () => api.get("/admin/verify");

// MacBooks
export const fetchMacbooks = (params = {}) => api.get("/macbooks", { params });
export const fetchMacbook = (id) => api.get(`/macbooks/${id}`);
export const createMacbook = (data) => api.post("/admin/macbooks", data);
export const updateMacbook = (id, data) => api.put(`/admin/macbooks/${id}`, data);
export const deleteMacbook = (id) => api.delete(`/admin/macbooks/${id}`);
export const markSold = (id) => api.post(`/admin/macbooks/${id}/sold`);

// Site Settings
export const fetchSiteSettings = () => api.get("/site-settings");
export const updateSiteSettings = (data) => api.put("/admin/site-settings", data);

// Orders
export const createOrder = (data) => api.post("/orders", data);
export const fetchOrders = () => api.get("/admin/orders");

// Upload
export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return api.post("/admin/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export default api;
